import Effects from 'Effects';
import Tone from 'tone';
import {PercentageValueParameter, AbstractParameter, ValueParameter} from 'parameters/AbstractParameter.js';

class PhaserEffect extends Effects.Effect {

    constructor(sequencerEngine) {
        super('Phaser', () => new Tone.Phaser(), sequencerEngine); 
        this.baseFrequencyParameter = new AbstractParameter(
            'Base Frequency', this.effectNode, (o, v) => o.baseFrequency = v, {
                min: 0,
                max: 10000,
                unit: 'hz',
                defaultValue: 400
            });
        this.registerParameter(this.baseFrequencyParameter);
        this.frequencyParameter = new AbstractParameter(
            'Frequency', this.effectNode, (o, v) => o.frequency.value = v, {
                min: 0,
                max: 10000,
                unit: '',
                defaultValue: 1
            });
        this.registerParameter(this.frequencyParameter);
        this.octaveParameter = new AbstractParameter(
            'Octaves', this.effectNode, (o, v) => o.octaves = v, {
                min: 0,
                max: 10,
                unit: '',
                defaultValue: 1
            });
        this.registerParameter(this.octaveParameter);
        this.qParameter = new ValueParameter(
            'Q', this.effectNode.Q, {
                min: 0,
                max: 10,
                unit: '',
                defaultValue: 0
            });
        this.registerParameter(this.qParameter);
    }

    getJson() {
        let json = super.getJson();
        json.name = this.name;
        json.baseFrequency = this.baseFrequencyParameter.get();
        json.frequency = this.frequencyParameter.get();
        json.octave = this.octaveParameter.get();
        json.q = this.qParameter.get();
        json.wet = this.wetParameter.get();
        return json;
    }

    fromJson(json, isCopy) {
        super.fromJson(json, isCopy);
        if ('baseFrequency' in json) {
            this.baseFrequencyParameter.set(json.baseFrequency);
        }
        if ('octave' in json) {
            this.octaveParameter.set(json.octave);
        }
        if ('frequency' in json) {
            this.frequencyParameter.set(json.frequency);
        }
        if ('q' in json) {
            this.qParameter.set(json.q);
        }
        if (json.enabled) {
            this.enable(true);
        }
        if ('wet' in json) {
            this.setValue(1);
        }
    }

    getEffectCopy(sequencerEngine=this.sequencerEngine, ignoreId=true) {
        var copy = new PhaserEffect(sequencerEngine);
        copy.fromJson(this.getJson(), ignoreId);
        return copy;
    }
}

export default PhaserEffect;
